let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("aquCq")).then(() => parcelRequire('5w7vf'));